<template>
  <Dialog :visible.sync="visible" :title="title" width="50%">
    <el-form :model="form" label-width="120px" ref="formRef" :rules="formRules">
      <el-form-item label="题库名称" prop="questionBankName">
        <el-input
          v-model.trim="form.questionBankName"
          placeholder="请输入题库名称"
          maxlength="30"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="题库类型" prop="questionBankType">
        <el-radio-group v-model="form.questionBankType">
          <el-radio :label="1">理论题库</el-radio>
          <el-radio :label="2">实操题库</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="关联课程" prop="courseId">
        <el-select v-model="form.courseId" placeholder="请选择关联课程">
          <el-option
            :label="item.courseName"
            :value="item.courseId"
            v-for="item in courseList"
            :key="item.courseId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="题库描述" prop="questionBankDesc">
        <el-input
          type="textarea"
          maxlength="50"
          v-model.trim="form.questionBankDesc"
          placeholder="请输入题库描述"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain round size="small" @click="cancel">取消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submit"
        >确定</el-button
      >
    </div>
  </Dialog>
</template>
<script>
import {
  addQuestionBank,
  updateQuestionBank
} from "@/api/questionBank";
import { getCourseList } from "@/api/course";
export default {
  name: "QuestionBankForm",
  data() {
    return {
      visible: false,
      title: "",
      form: { questionBankType: 1 },
      courseList: [],
      formType: "",
      submitLoading: false,
      formRules: {
        questionBankName: [
          { required: true, message: "请输入题库名称", trigger: "blur" }
        ],
        courseId: [
          { required: true, message: "请选择关联课程", trigger: "blur" }
        ],
        questionBankType: [
          { required: true, message: "请选择题库类型", trigger: "blur" }
        ],
        questionBankDesc: [
          { required: true, message: "请输入题库描述", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async open(type, id = null) {
      try {
        this.visible = true;
        this.title = type === "add" ? "新增题库" : "编辑题库";
        if (this.$route.path.includes("practical")) {
          this.form.questionBankType = 2;
        } else {
          this.form.questionBankType = 1;
        }
        // 教师端：关联课程取我的课程列表（courseTeacher/my-list）
        const courseRes = await getCourseList({
          pageNum: 1,
          pageSize: 500
        });
        this.courseList =
          (courseRes.data && courseRes.data.rows) || courseRes.data || [];
        this.formType = type;
      } finally {
      }
    },
    async submit() {
      if (this.submitLoading) return;
      try {
        this.submitLoading = true;
        await this.$refs.formRef.validate();

        if (this.formType === "add") {
          await addQuestionBank(this.form);
          this.$message.success("新增成功");
        } else {
          await updateQuestionBank(this.form);
          this.$message.success("编辑成功");
        }
        this.cancel();
        this.$emit("success");
      } catch (e) {
        console.log(e);
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.form = {};
      this.formType = "";
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.visible = false;
    }
  }
};
</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/QuestionBank/QuestionBankForm.vue